// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__gilroyBlack_37f1d4', '__gilroyBlack_Fallback_37f1d4'","fontWeight":900},"className":"__className_37f1d4","variable":"__variable_37f1d4"};